import { useState } from "react";
import axios from "axios";

export const useUploadAnexo = (urlApi, token, fetchAnexos) => {
    const [uploadStatus, setUploadStatus] = useState("");

    const uploadAnexo = async (file, id_chamado = null, id_usuario) => {
        if (!file) {
            setUploadStatus("Nenhum arquivo selecionado.");
            return;
        }

        const treatedName = file.name
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");

        const formData = new FormData();
        formData.append("file", file, treatedName);

        try {
            // 📤 Etapa 1: Upload do arquivo
            const uploadResponse = await axios.post(
                `${urlApi}central-ti/upload-anexo-servidor`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const { nome_salvo, tipo_arquivo, tamanho_arquivo } = uploadResponse.data;

            // 💾 Etapa 2: Salva no Oracle
            await axios.post(
                `${urlApi}central-ti/anexo`,
                {

                    id_chamado,
                    nome_original: treatedName,
                    nome_salvo,
                    tipo_arquivo,
                    tamanho_arquivo,
                    cod_funcionario: id_usuario,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setUploadStatus("Arquivo enviado e salvo com sucesso!");
            if (fetchAnexos) fetchAnexos();

        } catch (error) {
            // 🔥 Tratamento de erro com mensagens específicas
            if (error.response) {
                const msg = error.response.data?.message || "Erro ao fazer upload.";
                setUploadStatus(msg);
                alert(msg); // opcional
            } else {
                setUploadStatus("Erro de conexão com o servidor.");
                alert("Erro de conexão com o servidor.");
            }
        }
    };

    return { uploadAnexo, uploadStatus };
};
